module.exports = __webpack_public_path__ + "img/Figma_Logo.45c4f2d9.svg";